{
  "ordersInfo": {
    "ticker": "Тикер",
    "option": "Опцион",
    "tickerCompany": "Тикер/Комп",
    "operation": "Операция",
    "quantity": "Количество",
    "sum": "Сумма",
    "profitability": "Доходность",
    "dateTime": "Дата/Время",
    "actions": "Действия",
    "price": "Цена",
    "openedOrders": "Открытые ордера",
    "statusTitle": "Статус",
    "term": "Срок",
    "orderStatus": "Статус ордера",
    "orderStatusPlaceholder": "Выберите статус ордера",
    "orderType": "Тип ордера",
    "executed": "Исполнено",
    "averagePrice": "Средняя цена",
    "averageExecutedPrice": "Средняя исп. цена",
    "orderDuration": "Срок ордера",
    "profitabilityInPercent": "Доходность в %",
    "brokerCommission": "Комиссия брокера",
    "placed": "Дата размещения",
    "updated": "Дата обновления",
    "filled": "Дата исполнения",
    "canceled": "Дата отмены",
    "close": "Закрыть",
    "stopPrice": "Стоп цена",
    "limitPrice": "Лимит цена",
    "avgFilledPrice": "Средняя исп. цена",
    "stopLoss": "Stop Loss",
    "takeProfit": "Take Profit",
    "pcs": "шт.",
    "orderId": "ID",
    "status": {
      "new": "Новый",
      "partially_filled": "Частично",
      "filled": "Исполнен",
      "done_for_day": "Завершен на сегодня",
      "canceled": "Отменен",
      "expired": "Истек",
      "replaced": "Заменен",
      "pending_cancel": "Ожидает отмены",
      "pending_replace": "Ожидает замены",
      "accepted": "В обработке",
      "pending_new": "Ожидает создания",
      "rejected": "Отклонен",
      "calculated": "Вычисляется",
      "accepted_for_bidding": "Принят на торги",
      "stopped": "Остановлен",
      "suspended": "Приостановлен",
      "held": "Ожидает"
    },
    "side": {
      "buy": "Купить",
      "sell": "Продать",
      "sell_short": "Продажа в шорт"
    },
    "types": {
      "market": "Рыночный",
      "limit": "Лимитный",
      "stop": "Стоп",
      "stop_limit": "Стоп-лимитный",
      "trailing_stop": "Трейлинг-стоп"
    },
    "attributes": {
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit"
    },
    "terms": {
      "day": "DAY",
      "gtc": "GTC",
      "opg": "OPG",
      "cls": "CLS",
      "ioc": "IOC",
      "dayPlus": "DAY+"
    }
  }
}
